<!-- 手机验证码登录模块 -->
<template>
  <div class="verifyIDByMobile">
    <a-form :form="loginForm">
      <a-form-item :labelCol="layout.labelCol || { span: 5 }" :wrapperCol="!needLabel ? layout.wrapperCol || { offset: 5 } : {}" :label="(needLabel && labels.mobileLabel) || ''">
        <a-input :maxLength="11" :placeholder="labels.mobilePlaceholder" v-decorator="[
          'mobile',
          {
            rules: [
              { required: true, message: '请输入手机号码' },
              { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确' }
            ],
            validateTrigger: 'none'
          }
        ]" />
      </a-form-item>
      <a-form-item :labelCol="layout.labelCol || { span: 5 }" :wrapperCol="!needLabel ? layout.wrapperCol || { offset: 5 } : {}" :label="(needLabel && labels.verifyLabel) || ''">
        <div class="verify_box">
          <a-input :placeholder="labels.verifyPlaceholder" :maxLength="6" v-decorator="['code', { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'none' }]">
          </a-input>
          <button @click.stop.prevent="getCaptcha" class="verify_code">
            {{ state.send ? state.title : state.time + 's' }}
          </button>
        </div>
      </a-form-item>
      <!-- todo slot -->
      <a-form-item v-if="footer" :wrapperCol="layout.wrapperCol || { offset: 5 }">
        <a-button class="verify_btn" size="large" type="primary" @click="submit">下一步</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
// import { featchCode, existMobile } from '@/api/system'
import { resetPasswordSendSms, sendResetPasswordSmsCheck } from '@/api/forgotPwd'
import { mapState } from 'vuex'

export default {
  props: {
    layout: {
      type: Object,
      default: () => ({
        labelCol: { span: 5 },
        wrapperCol: { offset: 5 }
      })
    },
    // 是否需要label
    needLabel: {
      type: Boolean,
      default: true
    },
    // 表单文案
    labels: {
      type: Object,
      default: () => ({
        mobileLabel: '手机号码',
        mobilePlaceholder: '请输入手机号码',
        verifyLabel: '手机验证码',
        verifyPlaceholder: '请输入手机验证码'
      })
    },
    footer: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      info: state => state.system.orgInfo
    })
  },
  data() {
    return {
      loginForm: this.$form.createForm(this, { name: 'loginForm' }),
      checked: false,
      state: {
        title: '获取验证码',
        time: 60,
        send: true
      }
    }
  },
  methods: {
    submit() {
      this.loginForm.validateFields(async (error, values) => {
        if (error) return
        const { code = '', mobile = '' } = values
        const data = {
          ocode: this.info.ocode,
          phoneNumber: mobile,
          smsCode: code
        }
        const res = await sendResetPasswordSmsCheck(data)
        this.$emit('submit', { ...values, resetToken: res.resetToken || '', grant_type: 'stu_sms' })
      })
    },
    // 发送验证码
    getCaptcha() {
      const telphone = this.loginForm.getFieldValue('mobile')
      this.loginForm.validateFields(['mobile'], async (error, values) => {
        console.log(error)
        if (error || !this.state.send) {
          return
        }
        // const isExist = await existMobile({
        //   orgCode: this.$ls.get('code') || '',
        //   mobile: telphone
        // })
        // if (!isExist) {
        //   this.$message.error('你尚未注册账号')
        //   return
        // }
        const data = {
          ocode: this.info.ocode,
          phoneNumber: telphone
        }
        const res = await resetPasswordSendSms(data)
        // const res = await featchCode({ telphone })
        res && this.$message.success('发送成功，请注意查看')
        this.state.send = false
        this.timer = setInterval(() => {
          if (this.state.time-- <= 0) {
            this.state.title = '重新发送'
            this.state.time = 60
            this.state.send = true
            clearInterval(this.timer)
          }
        }, 1000)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.verifyIDByMobile {
  .verify_btn {
    width: 370px;
    height: 40px;
    background: #4b7dfd;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .verify_box {
    position: relative;
    width: 370px;
    line-height: 48px;
    .verify_code {
      position: absolute;
      right: 0;
      width: auto;
      line-height: 45px;
      padding: 0 18px;
      cursor: pointer;
      background: none;
      border: none;
      color: #1564ff;
      z-index: 2;
    }
  }
  .loginIsRegister {
    padding-bottom: 34px;
    margin-bottom: 12px;
    border-bottom: 1px solid #d6dae3;
  }
  .ant-form-item {
    display: flex;
    width: 100%;
    margin-bottom: 19px;
    &.ant-form-item-with-help {
      margin-bottom: 0;
    }
    /deep/ .ant-form-item-control-wrapper {
      // flex: 1;
      padding-left: 10px;
      .ant-form-item-label {
        line-height: 48px;
      }
      .ant-form-item-control {
        height: 100%;
        .ant-form-explain {
          font-size: 12px;
          line-height: 22px;
        }
      }
      input {
        width: 370px;
        height: 48px;
        background: #f5f8fa;
        border-radius: 6px;
      }
    }
  }
}
</style>
